/**
*
* InputIban
*
*/

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { string } from 'yup';
import Input from 'components/tags/Input/index.jsx'; // styled input
import messages from './messages.js';
import validateIban from './validateIban.js';
import { formatIban, sanitizeIban } from './helpers.js';

const StyledInput = styled(Input)`
  text-transform: uppercase;
  font-family: monospace;
`;

function InputIban(props) {
  const { value, onChange, onBlur } = props;
  const handleBlur = useCallback((e) => {
    onChange(sanitizeIban(e.target.value));
    if (onBlur) {
      onBlur(e);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <StyledInput type="text" {...props} value={formatIban(value)} onBlur={handleBlur}></StyledInput>
  );
}

InputIban.validate = validateIban;
InputIban.invalid = messages.invalid;

InputIban.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};

InputIban.getSchema = (options, intl) => {
  const { required } = options;
  let result = string().trim();
  if (required) {
    result = result.required();
  }
  return result.test({
    name: 'is-iban',
    message: intl.formatMessage(messages.invalid),
    test: validateIban,
  });
};

export default InputIban;
